import gql from 'graphql-tag';
import FieldsCreditBundle from 'graphql/fields/FieldsCreditBundle';
import FieldsCreditQrCode from 'graphql/fields/FieldsCreditQrCode';

export default gql(`
	query credit_qr_code( $guid: String! ) {
		credit_qr_code( guid: $guid ) {
			${FieldsCreditQrCode}

			timeslot_kind {
				guid
			}
		}
	}
`);

